var _circle, _circle2, _circle3, _g, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaturalPersonAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D0E0F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_57356",
    style: {
      maskType: "alpha"
    },
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#7B8694"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "#CB5353"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_57356)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 19.0643C19.5716 19.0643 22.4674 16.016 22.4674 12.2558C22.4674 8.49554 19.5716 5.44727 15.9993 5.44727C12.4271 5.44727 9.53125 8.49554 9.53125 12.2558C9.53125 16.016 12.4271 19.0643 15.9993 19.0643ZM15.9997 40.1685C22.2041 40.1685 27.2337 35.7485 27.2337 30.2962C27.2337 24.8438 22.2041 20.4238 15.9997 20.4238C9.79528 20.4238 4.76562 24.8438 4.76562 30.2962C4.76562 35.7485 9.79528 40.1685 15.9997 40.1685Z",
    fill: "#7A9CBF"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 5.5,
    fill: "#7AD1D1",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturalPersonAvatar);
export default __webpack_public_path__ + "static/media/natural-person-avatar.33a13b8d24e706f671375cd6f49b697e.svg";
export { ForwardRef as ReactComponent };